<template>
  <main id="bar-code-user">
    <div class="app-view-container">
      <el-row>
        <el-col class="app-view-title">
          {{ $t('barCodeUserType.title') }}
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <search-filter ref="searchFilter"/>
        </el-col>
      </el-row>
      <el-row class="search-summary-container bg-white">
        <el-col>
          <el-row class="default-section-header">
            <el-col :span="6" class="default-section-title">
              {{ $t('barCodeUserType.summary') }}
              <el-tooltip class="item" effect="dark" :enterable="false" :content="$t('common.refresh')" placement="top-start">
                <el-button @click="handleRefresh" icon="el-icon-refresh" size="mini" class="button-action-default search-summary-refresh-button"></el-button>
              </el-tooltip>
            </el-col>
            <el-col :span="18" class="default-section-actions text-align-end">
              <add-dialog-button />
            </el-col>
          </el-row>
          <el-row class="search-summary">
            <el-col>
              <search-summary />
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </main>
</template>
<script>
import SearchFilter from './SearchFilters';
import SearchSummary from './SearchSummary';
import AddDialogButton from './components/AddDialog';

export default {
  name: 'barCodeUser',
  components: {
    AddDialogButton,
    SearchFilter,
    SearchSummary
  },
  methods: {
    handleRefresh() {
      this.$refs.searchFilter.handleSearch();
    }
  }
};
</script>
